import classNames from 'classnames';
import { Field } from 'formik';
import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import FormErrorMessage from '../../../Form/formik/FormErrorMessage';
import selectors from '../../../../store/selectors';

import styles from './InputRegulationsAgree.module.scss';

const InputRegulationsAgree = ({ id, name }) => {
  const regulationsUrl = useSelector(selectors.selectRegulationsUrl);

  return (
    <div className="md-form input-group mt-0">
      <Field type="checkbox" id={id} name={name} className="form-check-input" />
      {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
      <label className={classNames(styles.label, 'form-check-label w-100')} htmlFor={name}>
        Akceptuję <a href={regulationsUrl}>Regulamin</a>
      </label>

      <FormErrorMessage name={name} />
    </div>
  );
};

InputRegulationsAgree.propTypes = {
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
};

export default InputRegulationsAgree;
